import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", null, "타입", -1)
const _hoisted_7 = {
  id: "codeTypes",
  hidden: "",
  required: ""
}
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", null, "코드", -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", null, "코드 이름", -1)
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-sm-12" }
const _hoisted_16 = { class: "form-group mb-5" }
const _hoisted_17 = {
  class: "c-switch c-switch-pill c-switch-primary",
  style: {"width":"50px"}
}
const _hoisted_18 = /*#__PURE__*/_createVNode("label", null, "사용여부", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("span", {
  class: "c-switch-slider",
  style: {"width":"40px"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubmitButton = _resolveComponent("SubmitButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createVNode("input", {
                list: "codeTypes",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.code_type = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.code_type]
              ]),
              _createVNode("datalist", _hoisted_7, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.saved_code_types, (codeType) => {
                  return (_openBlock(), _createBlock("option", {
                    value: codeType,
                    key: codeType
                  }, _toDisplayString(codeType), 9, ["value"]))
                }), 128))
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.code = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.code]
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.code_kor_name = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.code_kor_name]
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, [
              _createVNode("label", _hoisted_17, [
                _hoisted_18,
                _withDirectives(_createVNode("input", {
                  type: "checkbox",
                  class: "c-switch-input",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.use_yn_bool = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.use_yn_bool]
                ]),
                _hoisted_19
              ])
            ])
          ])
        ]),
        _createVNode(_component_SubmitButton, {
          text: "Add new",
          loadingText: " Saving...",
          isSubmitting: _ctx.isSubmitting
        }, null, 8, ["isSubmitting"])
      ], 32)
    ])
  ]))
}